var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifyOutline28(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6a6 6 0 00-6 6v5a4 4 0 01-.536 2h13.072A4 4 0 0120 17v-5a6 6 0 00-6-6zm10 13c-1.09 0-2-.91-2-2v-5a8 8 0 00-16 0v5c0 1.09-.91 2-2 2a1 1 0 100 2h20a1 1 0 100-2zm-12.232 4.135a1 1 0 011.367.363c.377.65 1.353.65 1.73 0a1 1 0 011.73 1.004A3.046 3.046 0 0114 25.997a3.046 3.046 0 01-2.595-1.495 1 1 0 01.363-1.367z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1a1 1 0 011 1v2.5h-2V2a1 1 0 011-1z"
  })));
}
export default SvgNotifyOutline28;